import React from 'react';
import { useDemoMode } from '../context/DemoModeContext';

/**
 * DemoModeToggle
 *
 * A compact toggle button for switching between teacher and student views.
 * Visible to admin and team captain users.
 */
const DemoModeToggle = () => {
  const { isStudentView, canSwitchView, toggleDemoMode } = useDemoMode();

  if (!canSwitchView) {
    return null;
  }

  const tooltip = isStudentView
    ? 'Switch to Teacher View'
    : 'Switch to Student View';

  return (
    <button
      className={`lrbrain-demo-toggle ${isStudentView ? 'lrbrain-demo-toggle--active' : ''}`}
      onClick={toggleDemoMode}
      title={tooltip}
      aria-label={tooltip}
      aria-pressed={isStudentView}
      type="button"
    >
      <span className="demo-icon" aria-hidden="true">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </span>
      <span className="demo-label">{isStudentView ? 'Teacher View' : 'Student View'}</span>
    </button>
  );
};

export default DemoModeToggle;
